import { type FunctionComponent } from 'react';
import { useStreetPageQuery } from '../../graphql/useStreetPageQuery';
import { StreetPageBannerWithData } from '../StreetPageBanner/StreetPageBannerWithData';
import { StreetPagePropertiesWithData } from '../StreetPageProperties/StreetPageProperties';
import { StreetPagePropertyCollectionBricksWithData } from '../StreetPagePropertyCollectionsBrick/StreetPagePropertyCollectionBricksWithData';
import { isNonEmptyArray } from '../../../app-kit/helpers/arrayHelpers';
import { StreetPageSuburbInsightsBannerWithData } from '../StreetPageSuburbInsightsBanner/StreetPageSuburbInsightsBannerWithData';

export const StreetPageContentWithData: FunctionComponent = () => {
  const collections = useStreetPageQuery()?.data?.streetPageBySlug?.propertyCollections ?? [];
  const hasCarousels = collections.some((collection) => isNonEmptyArray(collection?.properties));

  return (
    <>
      <StreetPageSuburbInsightsBannerWithData />
      <StreetPagePropertyCollectionBricksWithData />
      {hasCarousels ? (
        <>
          <StreetPageBannerWithData />
          <StreetPagePropertiesWithData />
        </>
      ) : (
        <>
          <StreetPagePropertiesWithData />
          <StreetPageBannerWithData />
        </>
      )}
    </>
  );
};
